module.exports = __webpack_public_path__ + "media/images/login-logo-f0fad5ad8d5078864f9be9384eb0316c.svg";